(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  function initHeroVideo() {
    const section = document.getElementById('Hero-{{ section.id }}');
    if (!section) {
      console.log('Section not found');
      return;
    }
    
    const video = section.querySelector('.ai-hero16__video');
    const playBtn = section.querySelector('.ai-hero16__play-btn');
    const audioBtn = section.querySelector('.ai-hero16__audio-btn');

    if (!video) {
      console.log('Video element not found');
      return;
    }

    console.log('Video controls initialized');

    // Set initial video state
    video.muted = true;
    video.playsInline = true;

    // Aggressive autoplay function
    function forcePlay() {
      video.muted = true;
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.then(() => {
          console.log('Video playing');
          if (playBtn) playBtn.classList.add('is-playing');
        }).catch((error) => {
          console.log('Autoplay prevented:', error);
          setTimeout(() => {
            video.play().catch(e => console.log('Retry failed:', e));
          }, 100);
        });
      }
    }

    // Try to play immediately
    forcePlay();

    // Try again when video is ready
    video.addEventListener('loadedmetadata', forcePlay);
    video.addEventListener('canplay', forcePlay);

    // Retry on user interaction
    const retryPlay = () => {
      if (video.paused) {
        forcePlay();
      }
    };
    
    document.addEventListener('click', retryPlay, { once: true });
    document.addEventListener('touchstart', retryPlay, { once: true });
    document.addEventListener('scroll', retryPlay, { once: true });

    // Play/Pause button handler
    if (playBtn) {
      playBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        console.log('Play button clicked, video paused:', video.paused);
        
        if (video.paused) {
          video.play()
            .then(() => {
              console.log('Video resumed');
              playBtn.classList.add('is-playing');
            })
            .catch(err => console.error('Play error:', err));
        } else {
          video.pause();
          console.log('Video paused');
          playBtn.classList.remove('is-playing');
        }
      });
    }

    // Audio toggle button handler
    if (audioBtn) {
      audioBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        console.log('Audio button clicked, currently muted:', video.muted);
        
        if (video.muted) {
          video.muted = false;
          audioBtn.classList.add('is-unmuted');
          console.log('Audio unmuted');
        } else {
          video.muted = true;
          audioBtn.classList.remove('is-unmuted');
          console.log('Audio muted');
        }
      });
    }

    // Sync play button with video state
    video.addEventListener('play', () => {
      console.log('Video play event');
      if (playBtn) playBtn.classList.add('is-playing');
    });

    video.addEventListener('pause', () => {
      console.log('Video pause event');
      if (playBtn) playBtn.classList.remove('is-playing');
    });

    // Sync audio button with volume changes
    video.addEventListener('volumechange', () => {
      console.log('Volume changed, muted:', video.muted);
      if (audioBtn) {
        if (video.muted) {
          audioBtn.classList.remove('is-unmuted');
        } else {
          audioBtn.classList.add('is-unmuted');
        }
      }
    });

    // Ensure video loops
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      video.play();
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroVideo);
  } else {
    initHeroVideo();
  }

  // Also initialize in Shopify theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initHeroVideo);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        } 
      },
      { once: true }
    );
  }

  // Grid density toggle for mobile
  document.addEventListener('DOMContentLoaded', function() {
    const gridDensityButtons = document.querySelectorAll('[data-grid-density]');
    const productGrid = document.querySelector('.product-grid');
    
    if (productGrid) {
      gridDensityButtons.forEach(button => {
        button.addEventListener('click', function() {
          const density = this.getAttribute('data-grid-density');
          
          // Remove existing mobile classes
          productGrid.classList.remove('product-grid-mobile--single', 'product-grid-mobile--large');
          
          // Add mobile class based on density
          if (density === 'comfortable' || density === 'compact') {
            productGrid.classList.add('product-grid-mobile--large');
          } else {
            productGrid.classList.add('product-grid-mobile--single');
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
